import map from 'lodash/map'
import React, { FC, useMemo } from 'react'

import { Page, PageSliderBlock as PageSliderBlockGraphData } from '@Generated/graphql'

import { PageSlider } from '../../Domains/Pages/Features/PageSlider/PageSlider'
import { PageSliderProps } from '../../Domains/Pages/Features/PageSlider/PageSlider.types'
import { getReferencesMatch } from '../../Shared/Utilities/GraphData/Reference.utils'

interface PageSliderBlockData extends PageSliderProps{
}

const getPageSliderBlockData = (pageSliderBlock: PageSliderBlockGraphData): PageSliderBlockData => {
  const refs: Page[] = getReferencesMatch(pageSliderBlock)
  const items = map(refs, ref => ({
    title: ref.openGraph?.title || '',
    imageUrl: ref.openGraph?.imageURL || '',
    description: ref.openGraph?.description || '',
    url: ref.url || '',
  }))
  return { items, title: pageSliderBlock.title || undefined }
}

interface PageSliderBlockProps {
  id?: string
  pageSliderBlock: PageSliderBlockGraphData
}

const PageSliderBlock: FC<PageSliderBlockProps> = ({
  id,
  pageSliderBlock,
}) => {
  const { items, title } = useMemo(() => getPageSliderBlockData(pageSliderBlock), [pageSliderBlock])

  return (
    <div
      id={id}
      style={{
        position: 'relative',
        width: '100%',
      }}
    >
      <PageSlider items={items} title={title} />
    </div>
  )
}

export default PageSliderBlock
